module.exports = __webpack_public_path__ + "static/img/checked-icon.194ee807.svg";